"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("g", {
    id: "wallet*"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "Icon (Stroke)",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M3.33372 2.60039C2.92872 2.60039 2.60039 2.92872 2.60039 3.33372C2.60039 3.73873 2.92872 4.06706 3.33372 4.06706L12.6671 4.06706C13.7348 4.06706 14.6004 4.93264 14.6004 6.00039V12.6671C14.6004 13.7348 13.7348 14.6004 12.6671 14.6004H3.33372C2.26597 14.6004 1.40039 13.7348 1.40039 12.6671V3.33372C1.40039 2.26597 2.26597 1.40039 3.33372 1.40039H11.3337C11.6651 1.40039 11.9337 1.66902 11.9337 2.00039C11.9337 2.33176 11.6651 2.60039 11.3337 2.60039H3.33372ZM2.60039 5.12313V12.6671C2.60039 13.0721 2.92872 13.4004 3.33372 13.4004H12.6671C13.0721 13.4004 13.4004 13.0721 13.4004 12.6671V6.00039C13.4004 5.59538 13.0721 5.26706 12.6671 5.26706L3.33372 5.26706C3.07415 5.26706 2.82653 5.2159 2.60039 5.12313ZM10.0671 9.33372C10.0671 8.81826 10.4849 8.40039 11.0004 8.40039C11.5159 8.40039 11.9337 8.81826 11.9337 9.33372C11.9337 9.84919 11.5159 10.2671 11.0004 10.2671C10.4849 10.2671 10.0671 9.84919 10.0671 9.33372Z",
    fill: fill
  })));
};

exports["default"] = _default;